import {FormComponent} from "../FormComponent";
import {Component} from "../Component";


export class EditProfileForm extends Component {
    static name = "edit-profile-form";

    get name() {
        return EditProfileForm.name;
    }

    constructor(el, props) {
        super(el);

        this.$editForm = this.$("editForm");
        this.$editBtn = this.$("editButton");
        this.$editBtnCancel = this.$("cancelButton");
        this.editForm = new FormComponent(this.$editForm, {
            resetOnComplete: false,
        });

        this.addEventListener(this.$editBtn, "click", this.onClickEdit.bind(this));
        this.addEventListener(this.$editBtnCancel, "click", this.onClickCancel.bind(this));
    }

    /**
     * OnClick Callback when edit profile button is clicked.
     *
     * Enables/Disables form to edit profile
     */
    onClickEdit() {
        console.log("onClickEdit");
        this.toggleEdit();
    }

    onClickCancel() {
        this.$editForm.reset();
        this.toggleEdit();
    }


    /**
     * Returns true if currently editing the edit profile form
     * @return {boolean}
     */
    isEditing() {
        return this.$editForm.classList.contains("--editing");
    }

    toggleEdit() {
        const elements = Array.from(this.$editForm.querySelectorAll("input,textarea,select")).filter(input => input.type !== "hidden");
        const wasEditing = this.isEditing();

        this.$editForm.classList[wasEditing ? "remove" : "add"]("--editing");

        elements.forEach((el) => {
            if (el.hasAttribute("data-disabled")) return;
            el.disabled = wasEditing;
        });

        console.log("toggleEdit", wasEditing, elements[0]);
        if (!wasEditing) {
            requestAnimationFrame(() => {
                elements[0].focus();
            });

        }

    }



}
